"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const hook_1 = require("../../../redux/hook");
const Utils_1 = require("../../../utils/Utils");
const tabs = [
    {
        id: "prametres-tarifs",
        title: "Tarifs des trajets & Gares de péage",
        field: "tarifs",
        link: "/admin/parametres/tarifs",
    },
    {
        id: "prametres-espaces",
        title: "Espaces & Catégories",
        field: "espaces",
        link: "/admin/parametres/espaces",
    },
    {
        id: "prametres-administrateurs",
        title: "Admins & Opérateurs PC & Managements",
        field: "administrateurs",
        link: "/admin/parametres/administrateurs",
    },
    {
        id: "parametres-directions",
        title: "Directions",
        field: "directions",
        link: "/admin/parametres/directions",
    },
    {
        id: "prametres-options",
        title: "Options",
        field: "options",
        link: "/admin/parametres/options",
    },
    {
        id: "prametres-faqs",
        title: "FAQs",
        field: "parametres",
        link: "/admin/parametres/faqs",
    },
    // {
    //     id: "prametres-politiques",
    //     title: "Politiques de confidentialité",
    //     link: "/admin/parametres/politiques",
    // },
];
const ParametresNavTab = () => {
    let location = (0, react_router_dom_1.useLocation)();
    let path = location === null || location === void 0 ? void 0 : location.pathname;
    const { user } = (0, hook_1.useAppSelector)((state) => state.user);
    return (react_1.default.createElement("div", { className: "custom_tabs__wrapper admin__settings__tabs" },
        react_1.default.createElement("ul", { className: "ps-0 settings__tabs tabs__container" }, tabs.map((tab, key) => {
            var _a;
            return (react_1.default.createElement(react_router_dom_1.NavLink, { role: "button", className: `tab_item 
                            ${(path === null || path === void 0 ? void 0 : path.startsWith(tab === null || tab === void 0 ? void 0 : tab.link))
                    ? "tab_item__active"
                    : ""}
                        `, to: `${tab === null || tab === void 0 ? void 0 : tab.link}`, key: key, title: tab === null || tab === void 0 ? void 0 : tab.title, hidden: (0, Utils_1.hasAccess)(user, (_a = user === null || user === void 0 ? void 0 : user.permissions) === null || _a === void 0 ? void 0 : _a[tab === null || tab === void 0 ? void 0 : tab.field]) },
                react_1.default.createElement("span", null, tab === null || tab === void 0 ? void 0 : tab.title)));
        }))));
};
exports.default = ParametresNavTab;
